// Achievement system

export const ACHIEVEMENTS = [
  { id: 'first_loan', title: 'First Deal', desc: 'Approve your first loan', emoji: '🤝', check: (s) => s.totalLoansApproved >= 1 },
  { id: 'ten_loans', title: 'Lending Machine', desc: 'Approve 10 loans', emoji: '🏭', check: (s) => s.totalLoansApproved >= 10 },
  { id: 'fifty_loans', title: 'Loan Shark', desc: 'Approve 50 loans', emoji: '🦈', check: (s) => s.totalLoansApproved >= 50 },
  { id: 'hundred_loans', title: 'Banking Titan', desc: 'Approve 100 loans', emoji: '👑', check: (s) => s.totalLoansApproved >= 100 },
  { id: 'million_profit', title: 'Millionaire', desc: 'Earn $1M in total profit', emoji: '💰', check: (s) => s.totalProfit >= 1000000 },
  { id: 'ten_million', title: 'Tycoon', desc: 'Grow capital to $10M', emoji: '🏛️', check: (s) => s.totalCapital >= 10000000 },
  { id: 'fifty_million', title: 'Banking Dynasty', desc: 'Grow capital to $50M', emoji: '🏰', check: (s) => s.totalCapital >= 50000000 },
  { id: 'no_defaults_5', title: 'Safe Hands', desc: '5 months with zero defaults', emoji: '🛡️', check: (s) => s.consecutiveNoDefaults >= 5 },
  { id: 'no_defaults_12', title: 'Iron Vault', desc: '12 months with zero defaults', emoji: '🔒', check: (s) => s.consecutiveNoDefaults >= 12 },
  { id: 'survivor', title: 'Crisis Survivor', desc: 'Survive a black swan event', emoji: '🦢', check: (s) => s.blackSwansSurvived >= 1 },
  { id: 'reject_all', title: 'The Gatekeeper', desc: 'Reject all loans in one month', emoji: '🚫', check: (s) => s.allRejectedMonth },
  { id: 'approve_all', title: 'Open Doors', desc: 'Approve all loans in one month', emoji: '🚪', check: (s) => s.allApprovedMonth },
  { id: 'high_risk', title: 'Daredevil', desc: 'Reach risk score of 80+', emoji: '🎲', check: (s) => s.peakRiskScore >= 80 },
  { id: 'year_one', title: 'First Year', desc: 'Complete 12 months', emoji: '📅', check: (s) => s.month >= 12 },
  { id: 'five_years', title: 'Veteran Banker', desc: 'Complete 60 months', emoji: '⭐', check: (s) => s.month >= 60 },
  { id: 'startup_king', title: 'Venture Capitalist', desc: 'Successfully collect on 10 startup loans', emoji: '🦄', check: (s) => s.startupLoansCompleted >= 10 },
  { id: 'low_rate', title: 'People\'s Banker', desc: 'Approve a loan at under 4%', emoji: '❤️', check: (s) => s.lowestRateApproved < 0.04 && s.lowestRateApproved > 0 },
  { id: 'high_rate', title: 'Loan Shark Supreme', desc: 'Approve a loan at over 25%', emoji: '🔱', check: (s) => s.highestRateApproved >= 0.25 },
];

export function checkAchievements(state, unlockedIds) {
  const newlyUnlocked = [];

  for (const achievement of ACHIEVEMENTS) {
    if (unlockedIds.has(achievement.id)) continue;
    if (achievement.check(state)) {
      newlyUnlocked.push(achievement);
    }
  }

  return newlyUnlocked;
}
